import Blockies from 'react-blockies';
import {Link} from 'react-router-dom';
import {useResolveEnsName} from 'src/hooks';
import {ConditionalWrapper} from 'src/utils';
import styles from './Address.module.scss';

export default function Address({
  address,
  size = 'large',
  isLinked = false,
}: {
  address: string;
  size?: 'small' | 'large';
  isLinked?: boolean;
}) {
  const resolved = useResolveEnsName(address);

  return (
    <div className={styles.container}>
      {size === 'large' && <Blockies className={styles.blockie} seed={address.toLowerCase()} />}
      <div className={styles.address}>
        <ConditionalWrapper
          wrap={isLinked}
          wrapper={(c) => <Link to={`/profiles/${address}`}>{c}</Link>}>
          {resolved}
        </ConditionalWrapper>
      </div>
    </div>
  );
}
